export const LOGIN = 'login'
export const LOGIN_REQUEST = 'loginRequest'
export const LOGIN_SUCCESS = 'loginSuccess'
export const LOGIN_ERROR = 'loginError'
export const LOGOUT = 'logout'
export const UPDATE_STATUS = 'updateStatus'
export const UPDATE_MOBILE_LOADING = 'updateMobileLoading'
export const CHANGE_AREA_LEVEL = 'changeAreaLevel'
export const CHANGE_SELECTED_PROVINCE = 'changeSelectedProvince'
export const CHANGE_SELECTED_DISTRICT = 'changeSelectedDistrict'
export const CHANGE_SELECTED_ZONE = 'changeSelectedZone'
export const CHANGE_SELECTED_SCHOOL = 'changeSelectedSchool'
export const CHANGE_SELECTED_TEACHER = 'changeSelectedTeacher'
export const CHANGE_MUTATION_INFO = 'changeMutationInfo'
export const TOGGLE_MODAL_PROVINCE = 'toggleModalProvince'
export const TOGGLE_MODAL_DISTRICT = 'toggleModalDistrict'
export const TOGGLE_MODAL_ZONE = 'toggleModalZone'
export const TOGGLE_MODAL_SCHOOL = 'toggleModalSchool'
export const TOGGLE_MODAL_MUTATION = 'toggleModalMutation'
export const TOGGLE_MODAL_RECAP_SCHOOL = 'toggleModalRecapSchool'
export const TOGGLE_MODAL_RECAP_DISTRICT = 'toggleModalRecapDistrict'
export const TOGGLE_MODAL_MUTATIONS = 'toggleModalMutations'
export const TOGGLE_MODAL_ABOUT = 'toggleModalAbout'
export const TOGGLE_MODAL_PROFILE = 'toggleModalProfile'
export const CHANGE_FULFILLMENT_DATA = 'changeFulfillmentData'
export const SHOW_PROVINCE_AREA = 'showProvinceArea'
export const DISABLE_TEACHER = 'disableTeacher'
